import swal from "sweetalert";
import axiosInstance from "../api";
import { setGetPurchaseReportData, setGetReportsData, setGetSalesReportData, setGetSalesValueData, setGetServiceIdSingle, setGetServices, setGetVatReportData, setGetVatReportsData, setgetRevenuedata } from "../reusable/reusableSlice";


export const getAllServicesList = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`user/service_list`, data);
    if (response?.data.status) {
      dispatch(setGetServices(response?.data?.response))
    } else {
      dispatch(setGetServices([]))
    }
    return response
  } catch (err) {
    console.error(err);
    dispatch(setGetServices([]))
  }
};

export const addNewService = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("user/add_service", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/services")
      // return response;
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

export const getSingleIdService = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`user/getby_service_id/${id}`);

    if (response?.data) {
      dispatch(setGetServiceIdSingle(response?.data?.response))
    } else {
      dispatch(setGetServiceIdSingle([]))
    }
  } catch (err) {
    console.error(err);
    dispatch(setGetServiceIdSingle([]))
  }
};

export const updateOneService = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("user/update_service", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/services")
      // return response;
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

export const deleteOneService = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.delete(`user/delete_service/${id}`);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      dispatch(getAllServicesList({
        search_key: "",
        page: 1,
        type: 1,
      }))
      // window.location.reload()
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
    // setLoading(false);
  }
};


export const getAllReportsData = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`invoice/get_report`, data);

    if (response?.data) {
      dispatch(setGetReportsData(response?.data?.response))
    } else {
      dispatch(setGetReportsData([]))
    }
  } catch (err) {
    console.error(err);
    dispatch(setGetReportsData([]))
  }
};

export const getAllReportsDatas = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`invoice/get_report`, data);

    if (response?.data) {
      dispatch(setGetVatReportData(response?.data?.response))
    } else {
      dispatch(setGetVatReportData([]))
    }
  } catch (err) {
    console.error(err);
    dispatch(setGetVatReportData([]))

  }
};

export const getRevenueOverViewData = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`invoice/get_report`, data);

    if (response?.data) {
      dispatch(setgetRevenuedata(response?.data?.response))
    } else {
      dispatch(setgetRevenuedata([]))
    }
  } catch (err) {
    console.error(err);
    dispatch(setgetRevenuedata([]))

  }
};

export const getAllSalesOverView = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`invoice/get_report`, data);

    if (response?.data) {
      dispatch(setGetSalesValueData(response?.data?.response))
    } else {
      dispatch(setGetSalesValueData([]))
    }
  } catch (err) {
    console.error(err);
    dispatch(setGetSalesValueData([]))
  }
};

export const getDownloadSalesReport = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`invoice/get_report_export`, data);

    if (response?.data) {
      dispatch(setGetSalesReportData(response?.data))
    } else {
      dispatch(setGetSalesReportData([]))
    }
  } catch (err) {
    console.error(err);
    dispatch(setGetSalesReportData([]))

  }
};

export const getDownloadPurchaseReport = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`invoice/get_report_export`, data);

    if (response?.data) {
      dispatch(setGetPurchaseReportData(response?.data))
    } else {
      dispatch(setGetPurchaseReportData([]))
    }
  } catch (err) {
    console.error(err);
    dispatch(setGetPurchaseReportData([]))

  }
};

export const getDownloadVatReport = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`invoice/get_report_export`, data);

    if (response?.data) {
      dispatch(setGetVatReportsData(response?.data))
    } else {
      dispatch(setGetVatReportsData([]))
    }
  } catch (err) {
    console.error(err);
    dispatch(setGetVatReportsData([]))

  }
};

export const getAllReports = async (data) => {
  try {
    const response = await axiosInstance.post(`/invoice/get_report`, data);
    return response
  } catch (err) {
    console.error(err, "reports error");
  }
};

export const exportAllReports = async (data) => {
  try {
    const response = await axiosInstance.post(`invoice/get_report_export`, data);
    return response
  } catch (err) {
    console.error(err);
  }
};